/**
 * Global Functionality
 * The logic in this is intended to ONLY contain any functionality
 * that is required on every page load.
 *
 * NOTE: Please do not include any page-specific logic here.
 **/

import Logger from "../lib/logger";

export default function () {
  const NAME = 'Global';
  Logger.info(`${NAME} > loading`);

  // Vars
  // ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
  const header = document.getElementById('theme-header');
  const hamburgerBtn = document.getElementById('hamburger-btn');


  // Logic
  // ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

  /**
   * init --- Initialization block
   */
  function init() {
    Logger.info(`${NAME} > init`);

    hamburgerBtn.addEventListener("click", (e) => {
      const newToggledState = hamburgerBtn.dataset.toggled === 'false' ? 'true' : 'false';
      header.dataset.toggled = newToggledState;
      hamburgerBtn.dataset.toggled = newToggledState;
      // navOverlay.dataset.opened = newToggledState;
    });
  }

  function checkElementLocation() {
    const windowHeight = window.innerHeight;
    const PADDING = 80;

    const fadeInObjects = [...document.querySelectorAll('[data-fade="ready"]')];
    const downObjects = [...document.querySelectorAll('[data-down="ready"]')];
    // console.log(`Window: ${windowHeight}`);

    const calculateBounds = (div, i, dataKey) => {
      setTimeout(function () {
        const elemRect = div.getBoundingClientRect();

        const bottom_of_object = elemRect.top;
        // console.log(`Object: ${bottom_of_object}`);
        // console.log(`Distance to view: ${windowHeight - bottom_of_object}`)

        if (windowHeight - PADDING > bottom_of_object) {
          div.dataset[dataKey] = 'in';
          setTimeout(function () {
            div.dataset[dataKey] = 'done';
          }, 800);
        }
      }, i * interval);
    };

    const interval = 200; // how much time should the delay between two iterations be (in milliseconds)?
    fadeInObjects.forEach((div, i) => calculateBounds(div, i, 'fade'));
    downObjects.forEach((div, i) => calculateBounds(div, i, 'down'));
  }

  // if in viewport, show the animation
  setTimeout(checkElementLocation, 0);
  document.addEventListener("scroll", checkElementLocation);


  // Do not edit below this line...
  // ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
  Logger.info(`${NAME} > loaded`);

  init();
}
